<div class="appHeader">
    <div class="left">
        <div *ngIf="showBack" class="back-btn" (click)="navigation.goBack()">
            <img src="assets/img/common/back-icon.png" alt="" class="st-icon">
        </div>
        <div *ngIf="showDownload" class="download-btn" (click)="downloadPage()">
            <div style="display: flex;">
                <h4>App</h4>&nbsp;
                <img src="assets/img/common/file-download-icon.png" alt="">
            </div>
        </div>
    </div>
    <div class="pageTitle">
        <img src="assets/img/logo.png"  alt="logo" width="100">
    </div>
    <div class="right">
        <div *ngIf="showNoti && isUserLoggedIn" class="notification-btn" (click)="notificationPage()">
            <img src="assets/img/common/notification-icon.png" alt="" class="st-icon">
            <span class="count" *ngIf="notiCount > 0">{{ notiCount }}</span>
        </div>
        <div *ngIf="showRefresh" class="refresh-btn" (click)="refreshPage()">
            <img src="assets/img/common/refresh-icon.png" alt="" class="st-icon">
        </div>
    </div>
</div>